const MOST_POPULAR_VEHICLES = (pagePath, model) => ({
    category: 'behavior_showroom_most_popular_vehicles',
    action: 'click',
    label: `${pagePath} | ${model}`,
});
const BODY_STYLE = (pagePath, bodyStyle) => ({
    category: 'ux_showroom_body_style',
    action: 'click',
    label: `${pagePath} | ${bodyStyle.toUpperCase()}`,
});
const SORT_BY = (pagePath, sortByWhat) => ({
    category: 'ux_showroom_sort_by',
    action: 'click',
    label: `${pagePath} | ${sortByWhat}`,
});
const ADJUST_MY_PAYMENT = (model) => ({
    category: 'ux_showroom_adjust_payment',
    action: 'click',
    label: `${model}`,
});
const PREPARE_YOUR_VISIT_CTA_NEW = (model) => ({
    category: 'ux_showroom_prepare_visit_cta_new',
    action: 'click',
    label: `${model}`,
});
const PREPARE_YOUR_VISIT_PROCESS_ENDED_NEW = (model) => ({
    category: 'ux_showroom_prepare_visit_process_ended_new',
    action: 'sent',
    label: `${model}`,
});
const PREPARE_YOUR_VISIT_CTA_USED = (model) => ({
    category: 'ux_showroom_prepare_visit_cta_used',
    action: 'click',
    label: `${model}`,
});
const PREPARE_YOUR_VISIT_PROCESS_ENDED_USED = (model) => ({
    category: 'ux_showroom_prepare_visit_process_ended_used',
    action: 'sent',
    label: `${model}`,
});
const RESERVE_IT_NOW_CTA_NEW = (model) => ({
    category: 'ux_showroom_reserve_it_now_cta_new',
    action: 'click',
    label: `${model}`,
});
const RESERVE_IT_NOW_PROCESS_ENDED_NEW = (model) => ({
    category: 'ux_showroom_reserve_it_now_process_ended_new',
    action: 'sent',
    label: `${model}`,
});
const RESERVE_IT_NOW_CTA_USED = (model) => ({
    category: 'ux_showroom_reserve_it_now_cta_used',
    action: 'click',
    label: `${model}`,
});
const RESERVE_IT_NOW_PROCESS_ENDED_USED = (model) => ({
    category: 'ux_showroom_reserve_it_now_process_ended_used',
    action: 'sent',
    label: `${model}`,
});
const EVALUATE_YOUR_PAYMENTSVDP = () => ({
    category: '',
    action: '',
    label: `pages VDP`,
});
const EVALUATE_MY_VEHICLE_CTA = (model) => ({
    category: 'ux_showroom_evaluate_my_vehicle_cta',
    action: 'click',
    label: `${model}`,
});
const ADD_TO_GARAGE_CTA_NEW = (model) => ({
    category: 'engagement_showroom_add_to_garage_cta_new',
    action: 'click',
    label: `${model}`,
});
const ADD_TO_GARAGE_CTA_USED = (model) => ({
    category: 'engagement_showroom_add_to_garage_cta_used',
    action: 'click',
    label: `${model}`,
});
const SPECS_SEE_ALL = (model) => ({
    category: 'ux_showroom_specs_sell_all',
    action: 'click',
    label: `${model}`,
});
const ADD_OR_MODIFY_ACCESSORIES_AND_OPTIONS = (model) => ({
    category: 'ux_showroom_add_modify_accessories_options',
    action: 'click',
    label: `${model}`,
});
const PREVIOUS_STEP_BTN = (pagePath, model) => ({
    category: 'ux_showroom_previous_step_btn',
    action: 'click',
    label: `${pagePath} | ${model}`,
});
const SEE_THE_COLLECTION = (model) => ({
    category: 'ux_showroom_see_the_collection',
    action: 'click',
    label: `${model}`,
});
const PAYMENT_TYPE = (paymentType) => ({
    category: 'ux_showroom_payment_type',
    action: 'click',
    label: `${paymentType}`,
});
const INITIAL_CASH_DOWN = () => ({
    category: 'ux_showroom_initial_cash_down',
    action: 'click',
    label: ``,
});
const TARGET_PAYMENT = (action, paymentValue) => ({
    category: 'ux_showroom_target_payment',
    action,
    label: paymentValue || ``,
});
const PREFERRED_FREQUENCY = () => ({
    category: 'ux_showroom_preferred_frequency',
    action: 'click',
    label: ``,
});
const MAXIMUM_TERM = () => ({
    category: 'ux_showroom_maximum_term',
    action: 'click',
    label: ``,
});
const EXCHANGE_VALUE__USED_CAR = (pagePath) => ({
    category: 'ux_showroom_exchange_value',
    action: 'click',
    label: `${pagePath}`,
});
const OWE_ON_TRADE = (pagePath) => ({
    category: 'ux_showroom_owe_on_trade',
    action: 'click',
    label: `${pagePath}`,
});
const LAYER_NAVIGATION__FILTERS = (pagePath, filter) => ({
    category: 'ux_showroom_layer_navigation_filter',
    action: 'click',
    label: `${pagePath} | ${filter}`,
});
const LOAD_MORE_BTN = (pagePath) => ({
    category: 'ux_showroom_load_more_btn',
    action: 'click',
    label: `${pagePath}`,
});
const ADDITIONNAL_PICTURES = (pagePath) => ({
    category: 'ux_showroom_additional_pictures',
    action: 'click',
    label: `${pagePath}`,
});
const USED_VDP_PICTURES = (pagePath) => ({
    category: 'ux_showroom_used_vdp_pictures',
    action: 'click',
    label: `${pagePath}`,
});
const USED_VDP_PICTURES__NEXT = (pagePath) => ({
    category: 'ux_showroom_used_vdp_pictures_next',
    action: 'click',
    label: `${pagePath}`,
});
const CARFAX_REPORT = (pagePath) => ({
    category: 'ux_showroom_carfax_report',
    action: 'click',
    label: `${pagePath}`,
});

const TRADE_IN_SELF_INSPECT = (pagePath) => ({
    category: 'ux_showroom_tradein_self_inspect',
    action: 'click',
    label: `${pagePath}`,
});

export default {
    MOST_POPULAR_VEHICLES,
    BODY_STYLE,
    SORT_BY,
    ADJUST_MY_PAYMENT,
    PREPARE_YOUR_VISIT_CTA_NEW,
    PREPARE_YOUR_VISIT_PROCESS_ENDED_NEW,
    PREPARE_YOUR_VISIT_CTA_USED,
    PREPARE_YOUR_VISIT_PROCESS_ENDED_USED,
    RESERVE_IT_NOW_PROCESS_ENDED_NEW,
    RESERVE_IT_NOW_PROCESS_ENDED_USED,
    RESERVE_IT_NOW_CTA_NEW,
    RESERVE_IT_NOW_CTA_USED,
    EVALUATE_YOUR_PAYMENTSVDP,
    EVALUATE_MY_VEHICLE_CTA,
    ADD_TO_GARAGE_CTA_NEW,
    ADD_TO_GARAGE_CTA_USED,
    SPECS_SEE_ALL,
    ADD_OR_MODIFY_ACCESSORIES_AND_OPTIONS,
    PREVIOUS_STEP_BTN,
    SEE_THE_COLLECTION,
    PAYMENT_TYPE,
    TARGET_PAYMENT,
    INITIAL_CASH_DOWN,
    PREFERRED_FREQUENCY,
    MAXIMUM_TERM,
    EXCHANGE_VALUE__USED_CAR,
    OWE_ON_TRADE,
    LAYER_NAVIGATION__FILTERS,
    LOAD_MORE_BTN,
    ADDITIONNAL_PICTURES,
    USED_VDP_PICTURES,
    USED_VDP_PICTURES__NEXT,
    CARFAX_REPORT,
    TRADE_IN_SELF_INSPECT,
};
